import {TooltipProvider} from '@/components/ui/tooltip';
import {Toaster} from '@/components/ui/sonner';
import React from 'react';
import './tailwind.css';
import './roboto.css';
import 'intro.js/introjs.css';
import './index.css';
import {createRoot} from 'react-dom/client';
import {Provider} from 'react-redux';
import {RouterProvider} from 'react-router-dom';
import {PersistGate} from 'redux-persist/integration/react';
import ReactGA from 'react-ga4';
import reportWebVitals from './reportWebVitals';
import {persistor, store} from './app/store';
import {router} from './app/router';
import {getConfigValue} from './app/utils/configUtils';
import {clarityInit} from './app/utils/analyticsUtils';
import {Config} from './app/types';

const container = document.getElementById('root')!;
const root = createRoot(container);

if (getConfigValue('clarityEnabled') && getConfigValue('clarityProjectId')) {
  // @ts-ignore
  clarityInit(getConfigValue('clarityProjectId'));
}

if (getConfigValue('googleAnalyticsEnabled') && getConfigValue('googleAnalyticsMeasurementId')) {
  // @ts-ignore
  ReactGA.initialize(getConfigValue('googleAnalyticsMeasurementId'));
}

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <TooltipProvider>
          <RouterProvider router={router} />
          <Toaster richColors position="top-right" />
        </TooltipProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

declare global {
  interface Window {
    config: Config;
  }
}

if (!Element.prototype.requestFullscreen) {
  Element.prototype.requestFullscreen =
    // @ts-expect-error polyfill
    Element.prototype.mozRequestFullscreen ||
    // @ts-expect-error polyfill
    Element.prototype.webkitRequestFullscreen ||
    // @ts-expect-error polyfill
    Element.prototype.msRequestFullscreen;
}

if (!document.exitFullscreen) {
  // @ts-expect-error polyfill
  document.exitFullscreen = document.mozExitFullscreen || document.webkitExitFullscreen || document.msExitFullscreen;
}
